// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"57":"index","589":"newsDetail","946":"news"}[chunkId] || chunkId) + "." + {"57":"fbc895be","518":"505d16e7","589":"e30cab44","946":"cf69df52"}[chunkId] + ".js";
};